<a class="text-dark" (click)="toggleFullScreen()"
  ><i data-feather="maximize"></i>
</a>
